export default "/images/vendor/flag-icons/flags/4x3/am.svg?683c20ed58f4d94748560f8529a6726d";